import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

// NOTE: All registered users now have FULL ACCESS to all features
// This hook now gives everyone unlimited access once logged in

const useSubscription = () => {
  const { user } = useAuth();

  // Memoize values to prevent unnecessary re-renders
  const subscriptionData = useMemo(() => {
    const subscriptionTier = user?.subscription_tier || 'free';
    const isLoggedIn = !!user;
    
    return {
      subscriptionTier,
      isLoggedIn,
      // All logged-in users now have full access
      hasSubscription: isLoggedIn,
      isPaidUser: isLoggedIn,  // Treat all users as paid
      isFreeUser: false,  // No one is restricted anymore
      isCrownUser: subscriptionTier === 'crown',
      isSeekersUser: subscriptionTier === 'seekers',
      hasAccess: isLoggedIn
    };
  }, [user]);

  // Helper functions - all return true for logged in users
  const hasFeatureAccess = (feature) => {
    // ALL REGISTERED USERS HAVE FULL ACCESS TO ALL FEATURES
    return !!user;
  };

  const getUsageLimit = (limitType) => {
    // Unlimited for all users
    return -1;
  };

  const isUnlimited = (limitType) => {
    // All users have unlimited access
    return true;
  };

  const requiresUpgrade = (feature) => {
    // No features require upgrade - all users have access
    return false;
  };

  const getUpgradeMessage = (feature) => {
    // No upgrade messages needed
    return '';
  };

  return {
    ...subscriptionData,
    limits: {}, // No limits
    hasFeatureAccess,
    getUsageLimit,
    isUnlimited,
    requiresUpgrade,
    getUpgradeMessage
  };
};

export { useSubscription };
export default useSubscription;
